import { Record } from 'immutable';
import type { z } from 'zod';

import { BankFeedStateShape, BankFeedUserPermissions, BankFeedUserPermissionsRecord } from './types';
import type { BankFeedUserPermissionsSchema } from './schemas';

export const UserPermissionsRecord = Record<BankFeedUserPermissions>({
  connectionManage: false,
  connectionView: false, // connectionView = connectionManage || transactionSync
  transactionSync: false,
  transactionView: false,
});

export const BankFeedUserPermissionsFactory = (
  apiData?: Partial<z.infer<typeof BankFeedUserPermissionsSchema>>,
): BankFeedUserPermissionsRecord => {
  return UserPermissionsRecord({
    connectionManage: apiData?.connection_manage ?? false,
    connectionView: apiData?.connection_view ?? false,
    transactionSync: apiData?.transaction_sync ?? false,
    transactionView: apiData?.transaction_view ?? false,
  });
};

export const BankFeedStateFactory = Record<BankFeedStateShape>({
  userPermissions: BankFeedUserPermissionsFactory(),
  userPermissionsLoaded: false,
});
